import { ERROR_API_NAME } from "../../constants/variables";

const errorMessages = {
  [ERROR_API_NAME.CURRENT_BOOKING_IN_STATE]: { code: 500, message: "No Booking in state", status: false },
  [ERROR_API_NAME.FLIGHT_AVALIABLE]: {
    code: 403,
    message: "Flights are not avaliable for the requested routes",
    status: false
  },
  [ERROR_API_NAME.CANCELLED_BOOKING_IN_STATE]: { code: 403, message: "Failed to fetch Cancelled Booking Status", status: false },
  [ERROR_API_NAME.MEAL_CATEGORIES]: { code: 403, message: "Failed to fetch meal categories", status: false },
  [ERROR_API_NAME.SSR_SELL_API]: { code: 403, message: "Failed to sell ssr", status: false }
};

export function errorHandingErrorMessage(apiType: any, _error: any = null) {
  return errorMessages[apiType] || { code: 500, message: "Something went wrong..", status: false };
}

export function errorHandingVoucherMessage(apiType: any, _error: any = null) {
  return { 
    data: {
      error: {
        message: _error.response?.data?.error?.message,
      }
    },
    status: false 
  };
}
